module.exports = __webpack_public_path__ + "static/media/v.b75dcdbf.png";